import { Button, Layout } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Logo } from "./Logo.js";
import { SearchBox } from "./SearchBox.js";

const { Header: AntHeader } = Layout;

export function AppHeader({ onToggleSidebar }: { onToggleSidebar?: () => void }) {
  return (
    <AntHeader
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        gap: 16,
        height: 60,
        padding: "0 20px",
        borderBottom: "1px solid var(--tn-border-faint)",
        background: "rgba(14, 15, 18, 0.85)",
        backdropFilter: "blur(10px) saturate(120%)",
        WebkitBackdropFilter: "blur(10px) saturate(120%)",
        boxShadow: "0 1px 0 rgba(0, 0, 0, 0.6)",
      }}
    >
      {onToggleSidebar && (
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
          className="header-menu-trigger"
        />
      )}
      <Logo />
      <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
        <SearchBox />
      </div>
    </AntHeader>
  );
}
